import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { Form, Button, Segment } from 'semantic-ui-react';
import ValidatedFormInput from 'components/ValidatedFormInput';
import {
  changeUserEmail,
  resetChangeUserEmailState,
} from 'state/changeUserEmail/actions';
import { emailValidation, idEmptyValidation } from 'utils/userMappingFormUtils';

const validate = values => {
  const errors = {};

  errors.old_email =
    idEmptyValidation(values.old_email) || emailValidation(values.old_email);
  errors.new_email =
    idEmptyValidation(values.new_email) || emailValidation(values.new_email);

  if (
    values.old_email &&
    values.new_email &&
    values.old_email === values.new_email
  ) {
    errors.new_email = 'New email must be different from old email';
  }

  return errors;
};

function ChangeUserEmailForm() {
  const dispatch = useDispatch();
  const { isLoading, success, error } = useSelector(
    state => state.changeUserEmail.main
  );

  const onSubmit = values => {
    dispatch(
      changeUserEmail({
        old_email: values.old_email.trim(),
        new_email: values.new_email.trim(),
      })
    );
  };

  const handleReset = () => {
    dispatch(resetChangeUserEmailState());
  };

  return (
    <FinalForm
      onSubmit={onSubmit}
      validate={validate}
      render={({ handleSubmit, form, pristine, invalid }) => (
        <Form onSubmit={handleSubmit}>
          <Field
            name="old_email"
            component={ValidatedFormInput}
            placeholder="Enter current email address"
            label="Current Email"
            type="email"
          />

          <Field
            name="new_email"
            component={ValidatedFormInput}
            placeholder="Enter new email address"
            label="New Email"
            type="email"
          />

          {error && (
            <Segment color="red">
              <p>Error: {error}</p>
            </Segment>
          )}

          {success && (
            <Segment color="green">
              <p>Email changed successfully!</p>
            </Segment>
          )}

          <Button
            type="submit"
            primary
            loading={isLoading}
            disabled={invalid || pristine}
          >
            Change Email
          </Button>

          <Button
            type="button"
            onClick={() => {
              form.reset();
              handleReset();
            }}
            disabled={isLoading}
          >
            Reset
          </Button>
        </Form>
      )}
    />
  );
}

export default ChangeUserEmailForm;
